import { render, staticRenderFns } from "./ClientPage.vue?vue&type=template&id=e839fe80&scoped=true&"
import script from "./ClientPage.vue?vue&type=script&lang=ts&"
export * from "./ClientPage.vue?vue&type=script&lang=ts&"
import style0 from "./ClientPage.vue?vue&type=style&index=0&id=e839fe80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e839fe80",
  null
  
)

export default component.exports